import { Box, styled } from '@mui/material'

import { DeliveryIcon } from 'components/common'

const PinContainer = styled(Box)({
  width: 60,
  height: 80,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
})

const CircleContainer = styled(Box)({
  width: 56,
  height: 56,
  borderRadius: '50%',
  backgroundColor: '#ffffff',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  boxShadow:
    '0px 2px 4px -1px rgb(0 0 0 / 20%), ' +
    '0px 4px 5px 0px rgb(0 0 0 / 14%), ' +
    '0px 1px 10px 0px rgb(0 0 0 / 12%)',
  zIndex: 1,
})

const InnerCircle = styled(Box)({
  width: 44,
  height: 44,
  borderRadius: '50%',
  backgroundColor: '#D4F4DD',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
})

const PinTail = styled(Box)({
  width: 0,
  height: 0,
  borderLeft: '8px solid transparent',
  borderRight: '8px solid transparent',
  borderTop: '12px solid #ffffff',
  marginTop: -2,
  filter: 'drop-shadow(0px 2px 2px rgba(0, 0, 0, 0.1))',
})

interface IProps {
  lat: number
  lng: number
}

const DeliveryCompletedIcon = (props: IProps) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { lat, lng } = props

  return (
    <PinContainer>
      <CircleContainer>
        <InnerCircle>
          <DeliveryIcon sx={{ fontSize: 32, color: '#2E7D32' }} />
        </InnerCircle>
      </CircleContainer>
      <PinTail />
    </PinContainer>
  )
}

export default DeliveryCompletedIcon
